import { IconButton, Modal, Stack, StackItem, Text } from '@fluentui/react';
import ImageEditor from '@toast-ui/react-image-editor';
import React, { useCallback, useMemo, useRef } from 'react';
import 'tui-image-editor/dist/tui-image-editor.css';
import './editor.css';

const Editor = (props) => {

    const {
        image = {},
        isOpen = false,
        onDismiss = () => null,
        onDismissed = () => null,
        onSave = (data, dataUrl) => null,
    } = props;

    const { fileName, src } = image;

    const editorRef = useRef();

    const styles = useMemo(
        () => ({
            button: { rootHovered: { backgroundColor: "inherit", color: "white" } },
            buttonIcon: { root: { color: "white" } },
            editor: { root: { height: "95%" } },
            header: {
                root: {
                    background: "red",
                    height: "5%",
                    padding: "0 18px 0 24px"
                }
            },
            headerText: { root: { color: "white" } },
            editor: { root: { height: "95%" } },
            modal: {
                main: {
                    height: "100%",
                    overflowY: "hidden",
                    width: "100%"
                },
                scrollableContent: { height: "100%" }
            }
        }), []
    );

    const _onSave = useCallback(() => {
        if (typeof onSave === "function") {
            const editorInstance = editorRef.current.getInstance();
            const dataUrl = editorInstance.toDataURL();
            const data = dataUrl.replace("data:image/png;base64,", "");
            onSave(data, dataUrl);
        }
    }, [editorRef, onSave]);

    return <Modal
        isOpen={isOpen}
        onDismiss={onDismiss}
        onDismissed={onDismissed}
        styles={styles.modal}
    >
        <Stack horizontal horizontalAlign="space-between" verticalAlign="center" styles={styles.header}>
            <Text variant="large" styles={styles.headerText}>{fileName}</Text>
            <Stack horizontal tokens={{ childrenGap: 11 }}>
                <IconButton
                    ariaLabel="Enregistrer les modifications"
                    iconProps={{ iconName: "Save", styles: styles.buttonIcon }}
                    onClick={_onSave}
                    styles={styles.button}
                    title="Enregistrer les modifications"
                />
                <IconButton
                    ariaLabel="Fermer"
                    iconProps={{ iconName: "ChromeClose", styles: styles.buttonIcon }}
                    onClick={onDismiss}
                    styles={styles.button}
                    title="Fermer"
                />
            </Stack>
        </Stack>
        <StackItem styles={styles.editor}>
            <ImageEditor
                ref={editorRef}
                includeUI={{
                    initMenu: "crop",
                    language: 'ko-KR',
                    loadImage: { path: src, name: fileName },
                    theme: {},
                    menu: ["crop", "flip", "rotate"],
                    menuBarPosition: "left",
                    uiSize: { height: "100%", width: "100%" }
                }}
                language={'ko-KR'}
                selectionStyle={{
                    cornerSize: 20, // Taille des carr�s qui permettent le redimensionnement / l'ajustement de la zone de crop
                    rotatingPointOffset: 70,
                }}
                usageStatistics
            />
        </StackItem>
    </Modal>;

};

export default Editor;